const CREATE_ROOM_WHEN_PLAY_MESSAGE = 'Create your own station to have your music played so others may enjoy it too!';

module.exports = {
    CREATE_ROOM_WHEN_PLAY_MESSAGE
};